import { render } from "./SpmTable.vue?vue&type=template&id=0de46ee9"
import script from "./SpmTable.vue?vue&type=script&lang=ts"
export * from "./SpmTable.vue?vue&type=script&lang=ts"

import "./SpmTable.vue?vue&type=style&index=0&id=0de46ee9&lang=scss"
import "./SpmTable.vue?vue&type=style&index=1&id=0de46ee9&lang=scss"
script.render = render

export default script